var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 16.6667V23.3333C3.33325 26.6667 4.99992 28.3333 8.33325 28.3333H10.7166C11.3333 28.3333 11.9499 28.5167 12.4833 28.8333L17.3499 31.8833C21.5499 34.5167 24.9999 32.6 24.9999 27.65V12.35C24.9999 7.38333 21.5499 5.48333 17.3499 8.11667L12.4833 11.1667C11.9499 11.4833 11.3333 11.6667 10.7166 11.6667H8.33325C4.99992 11.6667 3.33325 13.3333 3.33325 16.6667Z",
    stroke: "#01C37D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.3333C32.9667 17.2833 32.9667 22.7167 30 26.6667",
    stroke: "#01C37D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.05 9.16667C37.8667 15.5833 37.8667 24.4167 33.05 30.8333",
    stroke: "#01C37D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/Manage.39e65ebef82cb09651b175569d9e2cb3.svg";
export { ForwardRef as ReactComponent };